import { create } from "zustand";

type SupportChatStore = {
  isOpen: boolean;
  hasEverOpened: boolean;
  isLoading: boolean;
  open: () => void;
  close: () => void;
  setLoading: (loading: boolean) => void;
};

export const useSupportChatStore = create<SupportChatStore>()((set) => ({
  isOpen: false,
  hasEverOpened: false,
  isLoading: false,
  open: () => set({ isOpen: true, hasEverOpened: true, isLoading: true }),
  close: () => set({ isOpen: false, isLoading: false }),
  setLoading: (loading) => set({ isLoading: loading }),
}));
